import axios from "axios"
import Cookies from "js-cookie"
import { FIRMFLOWURL } from "./url";
export const updateChecklistItem = (form) => {
    return new Promise(async resolve => {
        try {
            const token = Cookies.get('Bearer');
            const response = await axios.put(`${FIRMFLOWURL}api/ServiceTaskChecklist/service-task/${form.task_id}/checklist/${form.id}`,
                {
                    description: form.description,
                    order: form.order,
                    links: form.links
                },
                {
                    headers: { 'Authorization': token }
                }
            )
            resolve(response);
        } catch (err) {
            console.log(err)
            if(err.message.includes(401)){
                Cookies.remove('Bearer');
                window.location.replace('/');
                return;
            }
            resolve({ success: false, message: err });
        }
    })
}